import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { useState } from "react";
import { getContextItemIndex } from "./auth-service-tools187.js";
import { useHovered } from "./auth-service-tools188.js";
import { useResolvedStylesApi } from "./auth-service-tools195.js";
import { useStyles } from "./auth-service-tools198.js";
import { useProps } from "./auth-service-tools225.js";
import { useDelayedHover } from "./auth-service-tools366.js";
import { Popover } from "./auth-service-tools264.js";
import { MenuContextProvider } from "./auth-service-tools376.js";
import { MenuDivider } from "./auth-service-tools377.js";
import { MenuDropdown } from "./auth-service-tools378.js";
import { MenuItem } from "./auth-service-tools379.js";
import { MenuLabel } from "./auth-service-tools380.js";
import { MenuTarget } from "./auth-service-tools381.js";
import classes from "./auth-service-tools382.js";
import { useUncontrolled } from "./auth-service-tools323.js";
import { useDidUpdate } from "./auth-service-tools369.js";
const defaultProps = {
  trapFocus: true,
  closeOnItemClick: true,
  clickOutsideEvents: ["mousedown", "touchstart", "keydown"],
  loop: true,
  trigger: "click",
  openDelay: 0,
  closeDelay: 100,
  menuItemTabIndex: -1
};

function Menu(_props) {
  const props = useProps("Menu", defaultProps, _props);
  const {
    children,
    onOpen,
    onClose,
    opened,
    defaultOpened,
    trapFocus,
    onChange,
    closeOnItemClick,
    loop,
    closeOnEscape,
    trigger,
    openDelay,
    closeDelay,
    classNames,
    styles,
    unstyled,
    variant,
    vars,
    menuItemTabIndex,
    keepMounted,
    ...others
  } = props;
  const getStyles = useStyles({
    name: "Menu",
    classes,
    props,
    classNames,
    styles,
    unstyled
  });
  const [hovered, {
    setHovered,
    resetHovered
  }] = useHovered();
  const [_opened, setOpened] = useUncontrolled({
    value: opened,
    defaultValue: defaultOpened,
    finalValue: false,
    onChange
  });
  const [openedViaClick, setOpenedViaClick] = useState(false);

  const close = () => {
    setOpened(false);
    setOpenedViaClick(false);
    _opened && (onClose == null ? void 0 : onClose());
  };

  const open = () => {
    setOpened(true);
    !_opened && (onOpen == null ? void 0 : onOpen());
  };

  const toggleDropdown = () => {
    _opened ? close() : open();
  };

  const {
    openDropdown,
    closeDropdown
  } = useDelayedHover({
    open,
    close,
    closeDelay,
    openDelay
  });

  const getItemIndex = node => getContextItemIndex("[data-menu-item]", "[data-menu-dropdown]", node);

  const {
    resolvedClassNames,
    resolvedStyles
  } = useResolvedStylesApi({
    classNames,
    styles,
    props
  });
  useDidUpdate(() => {
    resetHovered();
  }, [_opened]);
  return /* @__PURE__ */jsxRuntimeExports.jsx(MenuContextProvider, {
    value: {
      getStyles,
      opened: _opened,
      toggleDropdown,
      getItemIndex,
      hovered,
      setHovered,
      openedViaClick,
      setOpenedViaClick,
      closeOnItemClick,
      closeDropdown: trigger === "click" ? close : closeDropdown,
      openDropdown: trigger === "click" ? open : openDropdown,
      closeDropdownImmediately: close,
      loop,
      trigger,
      unstyled,
      menuItemTabIndex
    },
    children: /* @__PURE__ */jsxRuntimeExports.jsx(Popover, { ...others,
      opened: _opened,
      onChange: toggleDropdown,
      defaultOpened,
      trapFocus: keepMounted ? false : trapFocus,
      closeOnEscape,
      __staticSelector: "Menu",
      classNames: resolvedClassNames,
      styles: resolvedStyles,
      unstyled,
      variant,
      keepMounted,
      children
    })
  });
}

Menu.extend = input => input;

Menu.classes = classes;
Menu.displayName = "@mantine/core/Menu";
Menu.Item = MenuItem;
Menu.Label = MenuLabel;
Menu.Dropdown = MenuDropdown;
Menu.Target = MenuTarget;
Menu.Divider = MenuDivider;
export { Menu };